import { useSoftLogin } from '../hooks/useSoftLogin';

/** Mount once in root layout to boot third-party soft-login providers. */
export function SoftLoginEntry() {
  useSoftLogin();
  return null;
}
